import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";

export const CancelledList = () => {
  const [orderList, setOrderList] = useState([]);
  const [activeTab, setActiveTab] = useState("COMPLETED");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [cancellationReason, setCancellationReason] = useState("");
  const [orderToUpdate, setOrderToUpdate] = useState(null);


  // .............................<Ordre List By Tab Wise>.................................

  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = "https://api.kalmesh.in/BabyStepsAPI";

      try {
        const apiToken = sessionStorage.getItem("api_token");

        if (!apiToken) {
          console.error("API Token not found in session storage");
          return;
        }

        let status = undefined;

        switch (activeTab) {
          case "COMPLETED":
            status = "COMPLETED";
            break;
          case "PROCESSED":
            status = "PROCESSED";
            break;
          case "HOLD":
            status = "HOLD";
            break;
          case "RESHEDUCLED":
            status = "RESHEDUCLED";
            break;
          case "FINALIZED":
            status = "FINALIZED";
            break;
          case "PENDING":
            status = "PENDING";
            break;
          case "CANCELLED":
            status = "CANCELLED";
            break;
          default:
            break;
        }

        const response = await fetch(`${apiUrl}/order-list`, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            su_id: 1,
            status: status,
            api_token: apiToken,
            trans_from: "USER_APP",
          }),
        });

        const data = await response.json();
        console.log("API Response:", data);

        if (
          data.status === "success" &&
          Array.isArray(data.data) &&
          data.data.length > 0
        ) {
          setOrderList(data.data.reverse());
        } else {
          console.warn("Data not available");
          setOrderList([]);
        }
      } catch (error) {
        console.error("Error occurred while fetching data", error);
      }
    };

    fetchData();
  }, [activeTab]); 

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // ..............................<Update Oder status>.........................

  const handleStatusUpdate = async (orderId, status, cancelReason) => {
    try {
      const apiUrl = "https://api.kalmesh.in/BabyStepsAPI/update-order-status";

      const apiToken = sessionStorage.getItem("api_token");

      if (!apiToken) {
        console.error("API Token not found in session storage");
        return;
      }

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          su_id: 1, // Update with the appropriate user ID
          api_token: apiToken,
          order_id: orderId,
          status: status,
          cancelled_reason: cancelReason,
          trans_from: "SUPER_ADMIN",
        }),
      });

      const data = await response.json();
      console.log("Update Status Response:", data);

      // Handle the response as needed
      if (data.status === "success") {
        // Handle success case
        console.log("Order status updated successfully");
      } else {
        // Handle error case
        console.error("Failed to update order status");
      }
    } catch (error) {
      console.error("Error occurred while updating order status", error);
    }
  };


  // ...................................<Model Releted Code>............................


  const handleOpenModal = (order) => {
    setIsModalOpen(true);
    setOrderToUpdate(order);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // Reset selected status and cancellation reason on modal close
    setSelectedStatus("");
    setCancellationReason("");
  };

  const handleUpdateStatus = () => {
    // Call the function to update the status with selectedStatus and cancellationReason
    handleStatusUpdate(orderToUpdate.id, selectedStatus, cancellationReason);

    // Close the modal
    handleCloseModal();
  };


  return (
    <>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <h1 className="h3 mb-4 text-gray-800">Order List</h1>
              <ul className="nav nav-tabs">

                <li className="nav-item">
                  <button
                    style={{ margin: "2px", backgroundColor: "lightblue", color: "black" }}
                    className={`nav-link ${activeTab === "COMPLETED" ? "active" : ""
                      }`}
                    onClick={() => handleTabChange("COMPLETED")}
                  >
                    COMPLETED
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    style={{ margin: "2px", backgroundColor: "lightblue", color: "black" }}
                    className={`nav-link ${activeTab === "PROCESSED" ? "active" : ""
                      }`}
                    onClick={() => handleTabChange("PROCESSED")}
                  >
                    PROCESSED
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    style={{ margin: "2px", backgroundColor: "lightblue", color: "black" }}
                    className={`nav-link ${activeTab === "RESHEDUCLED" ? "active" : ""
                      }`}
                    onClick={() => handleTabChange("RESHEDUCLED")}
                  >
                    RESHEDUCLED
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    style={{ margin: "2px", backgroundColor: "lightblue", color: "black" }}
                    className={`nav-link ${activeTab === "FINALIZED" ? "active" : ""
                      }`}
                    onClick={() => handleTabChange("FINALIZED")}
                  >
                    FINALIZED
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    style={{ margin: "2px", backgroundColor: "lightblue", color: "black" }}
                    className={`nav-link ${activeTab === "PENDING" ? "active" : ""
                      }`}
                    onClick={() => handleTabChange("PENDING")}
                  >
                    PENDING
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    style={{ margin: "2px", backgroundColor: "lightblue", color: "black" }}
                    className={`nav-link ${activeTab === "CANCELLED" ? "active" : ""
                      }`}
                    onClick={() => handleTabChange("CANCELLED")}
                  >
                    CANCELLED
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    style={{ margin: "2px", backgroundColor: "lightblue", color: "black" }}
                    className={`nav-link ${activeTab === "HOLD" ? "active" : ""
                      }`}
                    onClick={() => handleTabChange("HOLD")}
                  >
                    HOLD
                  </button>
                </li>
                {/* Add more tabs as needed */}
              </ul>
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    {activeTab === "COMPLETED" ? "COMPLETED ORDERS" : `${activeTab} ORDERS`}
                  </h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                  <table
  className="table table-bordered"
  id="dataTable"
  width="100%"
  cellSpacing={0}
>
  <thead>
    <tr>
      <th>ID</th>
      <th>Order Number</th>
      <th>Rate</th>
      <th>Name</th>
      <th>Contact No</th>
      {activeTab === "PENDING" && <th>Action</th>}
      {activeTab === "CANCELLED" && <th>Cancelled Reason</th>}
    </tr>
  </thead>
  <tbody>
    {Array.isArray(orderList) && orderList.length > 0 ? (
      orderList.map((order) => (
        <tr key={order.id}>
          <td>{order.id}</td>
          <td>{order.order_number}</td>
          <td>{order.rate}</td>
          <td>{order.user_data.name}</td>
          <td>{order.user_data.mobile}</td>
         
           
            {activeTab === "PENDING" && (
               <td>
              <button
                className="btn btn-primary"
                onClick={() => handleOpenModal(order)}
              >
                Change Status
              </button>
              </td>
              )} 
            
            {activeTab === "CANCELLED" && (
                <td>{order.cancelled_reason}</td>
                )}
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="5">
          {activeTab
            ? "No data available for any status."
            : `No data available for ${activeTab} orders.`}
        </td>
      </tr>
    )}
  </tbody>
</table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {isModalOpen && (
        <div className="form-popup-bg is-visible">
          <div className="form-container">
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <h3>Change Order Status</h3>
            <form action="">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <select
                  type="text"
                  className="form-control"
                  id="name"
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  value={selectedStatus}
                >
                  <option hidden>Select Status</option>
                  <option>CANCELLED</option>
                  <option>PROCESSED</option>
                  <option>COMPLETED</option>
                  <option>HOLD</option>
                  <option>RESHEDUCLED</option>
                  <option>FINALIZED</option>
                </select>
              </div>

              {selectedStatus === "CANCELLED" && (
                <div className="form-group">
                  <label htmlFor="cancelReason">Cancel Reason</label>
                  <input
                    type="text"
                    className="form-control"
                    id="cancelReason"
                    placeholder="Enter the reason for cancellation"
                    onChange={(e) => setCancellationReason(e.target.value)}
                    value={cancellationReason}
                  />
                </div>
              )}

              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ margin: "2px" }}
                  onClick={handleUpdateStatus}
                >
                  Update Status
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  style={{ margin: "2px" }}
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n  \n\n.form-popup-bg {\n  position:absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  justify-content: center;\n}\n.form-popup-bg {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(94, 110, 141, 0.6);\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;\n  -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;\n  transition: opacity 0.3s 0s, visibility 0s 0.3s;\n  overflow-y: auto;\n  z-index: 10000;\n}\n.form-popup-bg.is-visible {\n  opacity: 1;\n  visibility: visible;\n  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;\n  -moz-transition: opacity 0.3s 0s, visibility 0s 0s;\n  transition: opacity 0.3s 0s, visibility 0s 0s;\n}\n.form-container {\n    background-color: white;\n    border-radius: 10px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 700px;\n    margin-left: auto;\n    margin-right: auto;\n    position:relative;\n  padding: 40px;\n  color: black;\n}\n.close-button {\n  background:none;\n  color:black;\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: solid 1px #fff;\n}\n\n.form-popup-bg:before{\n    content:'';\n    background-color: black;\n  opacity: .25;\n  position:absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n\n\n\n  "
        }}
      />

    </>
  );
};
